<script setup lang="ts">
    import { ref, watch, type Ref } from 'vue';
    import { ChannelIcon } from '@/js/services/api/interaction/types';
    import InteractionTypeIcon from '../interactions/InteractionTypeIcon.vue';
    import EchoTooltip from '../EchoTooltip.vue';
    import {
        InteractionTableStoreName,
        useInteractionTableStoreByName,
    } from '@/js/stores/interactions-table';

    const props = defineProps<{
        rowId?: string;
        title: string;
        subtitle: string;
        channelIcon: ChannelIcon;
        checked: boolean;
        tableStoreName: InteractionTableStoreName;
        grayScale?: boolean;
        isNew?: boolean;
    }>();

    const tableStore = useInteractionTableStoreByName(props.tableStoreName);

    const titleEl = ref<HTMLElement | null>(null);
    const subtitleEl = ref<HTMLElement | null>(null);
    const isTitleTruncated = ref(false);
    const isSubtitleTruncated = ref(false);

    const checkTruncation = (el: HTMLElement | null, isTruncated: Ref<boolean>) => {
        if (el) isTruncated.value = el.scrollWidth > el.clientWidth;
    };

    watch(titleEl, (el) => checkTruncation(el, isTitleTruncated), { flush: 'post' });
    watch(subtitleEl, (el) => checkTruncation(el, isSubtitleTruncated), { flush: 'post' });
</script>
<template>
    <div
        class="flex h-full gap-3 items-center flex-start px-3 relative"
        :class="grayScale ? 'gray-scale' : ''"
    >
        <input
            v-if="tableStore.selectionMode"
            :checked="checked"
            type="checkbox"
            class="relative z-10"
            @change="tableStore.toggleRowSelection(props.rowId ?? props.title)"
        />
        <InteractionTypeIcon :is-new="isNew" :channel-icon="channelIcon" :gray-scale="grayScale" />
        <div class="min-w-0">
            <EchoTooltip :label="title" :disabled="!isTitleTruncated" class="block min-w-0">
                <p ref="titleEl" class="text-caption-bold truncate">
                    {{ title }}
                </p>
            </EchoTooltip>
            <EchoTooltip :label="subtitle" :disabled="!isSubtitleTruncated" class="block min-w-0">
                <p ref="subtitleEl" class="text-caption truncate">
                    {{ subtitle }}
                </p>
            </EchoTooltip>
        </div>
    </div>
</template>
